

import { Badge } from "@/components/ui/badge";

interface SessionTechniquesProps {
  techniques?: string[];
}

export function SessionTechniques({ techniques }: SessionTechniquesProps) {
  if (!techniques || techniques.length === 0) return null;

  return (
    <div>
      <h3 className="text-sm font-medium mb-2">Techniques:</h3>
      <div className="flex flex-wrap gap-2">
        {techniques.map((technique, idx) => (
          <Badge key={idx} variant="secondary">
            {technique}
          </Badge>
        ))}
      </div>
    </div>
  );
}
